<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="24" height="24" rx="12" fill="#1C2026" />
        <path
            d="M8.11133 8.11133L15.8891 15.8891M15.8891 8.11133L8.11133 15.8891"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
        />
    </svg>
</template>
